<template>
  <div class="help-wrapper">
    <search-form :fields="searchFields" @on-search="toSearch" @on-reset="toReset" :okLoading="loading"></search-form>
    <div class="help-content" :style="{height: tableHeight + 'px'}">
      <div class="table-top">
        <Button @click="toOpr('add')" v-has-permi="['PRIV_MENUS_CREATE']"><Icon type="md-add"/> 新增</Button>
      </div>
      <Table row-key="id" stripe :columns="columns" :data="list" :loading="loading" ref="table" :height="tableHeight"></Table>
    </div>
    <Modal :title="oprType === 'add' ? '新增' : '编辑'"
           v-model="showModal"
           class="modal-detail modal-form"
           class-name="vertical-center-modal"
           :mask-closable="false"
           width="800">
      <div slot="footer">
        <Button @click="modalCancel">取消</Button>
        <Button type="primary" @click="modalOk" :disabled="btnLoading" :loading="btnLoading">确定</Button>
      </div>
      <Form :model="modalFormData" ref="modalForm" :label-width="120" :rules="modalRuleValid">
        <div class="form-content">
          <FormItem label="菜单类型: " prop="type" class="long">
            <RadioGroup v-model="modalFormData.type" type="button" button-style="solid" @on-change="typeChange">
              <Radio v-for="(opt, oInd) in menuTypeOpt" :key="oInd" :label="opt.value">{{opt.label}}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="上级菜单" prop="parentUID" class="long">
              <Input v-model="modalFormData.parentUID" disabled  v-if="modalFormData.type === 0"/>
                <Tree-select :modelValue="modalFormData.parentUID"
                             :filterable="true"
                             :multiple="false"
                             :clearable="true"
                             v-if="modalFormData.type === 1 && showModal"
                             @on-change="treeChange"
                             :data="modalTreeList"></Tree-select>
          </FormItem>
          <FormItem label="菜单图标" prop="icon" class="long">
            <Select v-model="modalFormData.icon" :clearable="true" :filterable="true" class="icon-select">
              <Option v-for="(opt, oInd) in iviewIconList" :key="oInd" :value="opt" :label="opt">
                <Icon :type="opt"></Icon>
                <span :title="opt">{{opt}}</span>
              </Option>
              <Option v-for="(opt, oInd) in iconfontList" :key="oInd + iviewIconList.length" :value="opt" :label="opt">
                <i class="iconfont" :class="opt"></i>
                <span :title="opt">{{opt}}</span>
              </Option>
            </Select>
          </FormItem>
          <FormItem label="菜单名称" prop="name" class="half">
            <Input v-model="modalFormData.name" />
          </FormItem>
          <FormItem label="显示排序" prop="sortIndex" class="half">
            <Input type="number" v-model="modalFormData.sortIndex" />
          </FormItem>
          <FormItem label="路由地址" prop="path" class="half">
            <Input v-model="modalFormData.path" />
          </FormItem>
          <FormItem label="组件路径" prop="component" class="half">
            <Input v-model="modalFormData.component" />
          </FormItem>
          <template v-if="modalFormData.type === 1">
            <FormItem label="权限标识" prop="viewPower" class="half">
              <Select v-model="modalFormData.viewPower" :filterable="true" @on-query-change="powerChange">
                <Option v-for="(opt, oInd) in powerList"
                        :key="oInd"
                        :value="opt.name" :label="opt.name + ' | ' + opt.description + ' - '+ opt.page"></Option>
              </Select>
            </FormItem>
          </template>
          <FormItem label="是否外链" prop="isFrame" class="half">
            <RadioGroup v-model="modalFormData.isFrame">
              <Radio v-for="(opt, oInd) in isValidOpt" :key="oInd" :label="opt.value - 1">{{opt.label}}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="显示状态" prop="hidden" class="half">
            <RadioGroup v-model="modalFormData.hidden">
              <Radio v-for="(opt, oInd) in isValidOpt" :key="oInd" :label="opt.value - 1">{{opt.label}}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="显示缓存" prop="keepAlive" class="half">
            <RadioGroup v-model="modalFormData.keepAlive">
              <Radio v-for="(opt, oInd) in isValidOpt" :key="oInd" :label="opt.value - 1">{{opt.label}}</Radio>
            </RadioGroup>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm'
import TreeSelect from '@/components/tree-select'
import { mapState } from 'vuex'
import { menuTypeOpt, isValidOpt } from '@/libs/dict'
import { getMenusQuery, setMenusAdd, setMenusMod, setMenusDel, getPowersQuery } from '@/libs/api'
let formData = {
  type: 0,
  name: '',
  icon: '',
  path: '',
  component: '',
  sortIndex: 1,
  viewPower: '',
  parentUID: '-1',
  remark: '',
  hidden: 1,
  system: 0,
  isFrame: 0,
  keepAlive: 0
}
export default {
  name: "menus",
  components: {
    SearchForm,
    TreeSelect
  },
  data () {
    return {
      menuTypeOpt,
      isValidOpt,
      searchFields: [
        {
          label: '菜单名称',
          name: 'name',
          type: 'input'
        }
      ],
      searchParams: {},
      loading: false,
      columns: [
        {
          key: 'name',
          title: '菜单名称',
          align: 'center',
          minWidth: 150,
          tree: true
        },
        {
          key: 'icon',
          title: '图标',
          align: 'center',
          width: 80,
          render: (h, params) => {
            let icon = params.row.icon
            // console.log(icon)
            let tpl = icon.indexOf('icon-') > -1 ? h('i', { class: 'iconfont ' + icon}) : h('Icon', {
              props: {
                type: icon
              }
            })
            return tpl
          }
        },
        {
          key: 'sortIndex',
          title: '排序',
          align: 'center',
          width: 80
        },
        {
          key: 'isFrame',
          title: '是否外链',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let str = params.row.isFrame ? '是' : '否'
            return (<span>{str}</span>)
          }
        },
        {
          key: 'viewPower',
          title: '权限标识',
          align: 'center',
          width: 100,
          tooltip: true
        },
        {
          key: 'path',
          title: '路由地址',
          align: 'center',
          width: 120
        },
        {
          key: 'component',
          title: '组件路径',
          align: 'center',
          width: 150
        },
        {
          key: 'keepAlive',
          title: '是否缓存',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let str = params.row.isFrame ? '是' : '否'
            return (<span>{str}</span>)
          }
        },
        {
          key: 'hidden',
          title: '显示状态',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let str = !params.row.hidden ? '是' : '否'
            return (<span>{str}</span>)
          }
        },
        {
          key: 'opr',
          title: '操作',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return (
                <span class="table-opr-btn">
                <a href="javascript:;" class="mod" onClick={this.toOpr.bind(this, 'mod', params.row)} v-has-permi={['PRIV_MENUS_UPDATE']}>
                  <i class="iconfont icon-bianji"></i> 编辑</a>
                <a href="javascript:;" class="mod" onClick={this.toOpr.bind(this, 'del', params.row)} v-has-permi={['PRIV_MENUS_DELETE']}>
                  <i class="iconfont icon-shanchu"></i> 删除</a>
              </span>
            )
          }
        }
      ],
      list: [],
      oprType: '',
      modData: {},
      showModal: false,
      btnLoading: false,
      modalFormData: Object.assign({}, formData),
      modalRuleValid: {
        name: [{required: true, message: '请输入菜单名称!'}],
        sortIndex: [{required: true, message: '请输入排序!'}],
        path: [{required: true, message: '请输入路由地址!'}],
        component: [{required: true, message: '请输入组件路径!'}],
        parentUID: [{required: true, message: '请选择上级菜单!'}],
        icon: [{required: true, message: '请选择图标!'}]
      },
      iviewIconList: [
        'ios-add','md-add','ios-add-circle','ios-add-circle-outline','md-add-circle','ios-alarm','ios-alarm-outline','md-alarm','ios-albums','ios-albums-outline','md-albums','ios-alert','ios-alert-outline','md-alert','ios-american-football','ios-american-football-outline','md-american-football','ios-analytics','ios-analytics-outline','md-analytics','logo-android','logo-angular','ios-aperture','ios-aperture-outline','md-aperture','logo-apple','ios-apps','ios-apps-outline','md-apps','ios-appstore','ios-appstore-outline','md-appstore','ios-archive','ios-archive-outline','md-archive','ios-arrow-back','md-arrow-back','ios-arrow-down','md-arrow-down','ios-arrow-dropdown','md-arrow-dropdown','ios-arrow-dropdown-circle','md-arrow-dropdown-circle','ios-arrow-dropleft','md-arrow-dropleft','ios-arrow-dropleft-circle','md-arrow-dropleft-circle','ios-arrow-dropright','md-arrow-dropright','ios-arrow-dropright-circle','md-arrow-dropright-circle','ios-arrow-dropup','md-arrow-dropup','ios-arrow-dropup-circle','md-arrow-dropup-circle','ios-arrow-forward','md-arrow-forward','ios-arrow-round-back','md-arrow-round-back','ios-arrow-round-down','md-arrow-round-down','ios-arrow-round-forward','md-arrow-round-forward','ios-arrow-round-up','md-arrow-round-up','ios-arrow-up','md-arrow-up','ios-at','ios-at-outline','md-at','ios-attach','md-attach','ios-backspace','ios-backspace-outline','md-backspace','ios-barcode','ios-barcode-outline','md-barcode','ios-baseball','ios-baseball-outline','md-baseball','ios-basket','ios-basket-outline','md-basket','ios-basketball','ios-basketball-outline','md-basketball','ios-battery-charging','md-battery-charging','ios-battery-dead','md-battery-dead','ios-battery-full','md-battery-full','ios-beaker','ios-beaker-outline','md-beaker','ios-beer','ios-beer-outline','md-beer','ios-bicycle','md-bicycle','logo-bitcoin','ios-bluetooth','md-bluetooth','ios-boat','ios-boat-outline','md-boat','ios-body','ios-body-outline','md-body','ios-bonfire','ios-bonfire-outline','md-bonfire','ios-book','ios-book-outline','md-book','ios-bookmark','ios-bookmark-outline','md-bookmark','ios-bookmarks','ios-bookmarks-outline','md-bookmarks','ios-bowtie','ios-bowtie-outline','md-bowtie','ios-briefcase','ios-briefcase-outline','md-briefcase','ios-browsers','ios-browsers-outline','md-browsers','ios-brush','ios-brush-outline','md-brush','logo-buffer','ios-bug','ios-bug-outline','md-bug','ios-build','ios-build-outline','md-build','ios-bulb','ios-bulb-outline','md-bulb','ios-bus','ios-bus-outline','md-bus','ios-cafe','ios-cafe-outline','md-cafe','ios-calculator','ios-calculator-outline','md-calculator','ios-calendar','ios-calendar-outline','md-calendar','ios-call','ios-call-outline','md-call','ios-camera','ios-camera-outline','md-camera','ios-car','ios-car-outline','md-car','ios-card','ios-card-outline','md-card','ios-cart','ios-cart-outline','md-cart','ios-cash','ios-cash-outline','md-cash','ios-chatboxes','ios-chatboxes-outline','md-chatboxes','ios-chatbubbles','ios-chatbubbles-outline','md-chatbubbles','ios-checkbox','ios-checkbox-outline','md-checkbox','md-checkbox-outline','ios-checkmark','md-checkmark','ios-checkmark-circle','ios-checkmark-circle-outline','md-checkmark-circle','md-checkmark-circle-outline','logo-chrome','ios-clipboard','ios-clipboard-outline','md-clipboard','ios-clock','ios-clock-outline','md-clock','ios-close','md-close','ios-close-circle','ios-close-circle-outline','md-close-circle','ios-closed-captioning','ios-closed-captioning-outline','md-closed-captioning','ios-cloud','ios-cloud-outline','md-cloud','ios-cloud-circle','ios-cloud-circle-outline','md-cloud-circle','ios-cloud-done','ios-cloud-done-outline','md-cloud-done','ios-cloud-download','ios-cloud-download-outline','md-cloud-download','md-cloud-outline','ios-cloud-upload','ios-cloud-upload-outline','md-cloud-upload','ios-cloudy','ios-cloudy-outline','md-cloudy','ios-cloudy-night','ios-cloudy-night-outline','md-cloudy-night','ios-code','md-code','ios-code-download','md-code-download','ios-code-working','md-code-working','logo-codepen','ios-cog','ios-cog-outline','md-cog','ios-color-fill','ios-color-fill-outline','md-color-fill','ios-color-filter','ios-color-filter-outline','md-color-filter','ios-color-palette','ios-color-palette-outline','md-color-palette','ios-color-wand','ios-color-wand-outline','md-color-wand','ios-compass','ios-compass-outline','md-compass','ios-construct','ios-construct-outline','md-construct','ios-contact','ios-contact-outline','md-contact','ios-contacts','ios-contacts-outline','md-contacts','ios-contract','md-contract','ios-contrast','md-contrast','ios-copy','ios-copy-outline','md-copy','ios-create','ios-create-outline','md-create','ios-crop','ios-crop-outline','md-crop','logo-css3','ios-cube','ios-cube-outline','md-cube','ios-cut','ios-cut-outline','md-cut','logo-designernews','ios-desktop','ios-desktop-outline','md-desktop','ios-disc','ios-disc-outline','md-disc','ios-document','ios-document-outline','md-document','ios-done-all','md-done-all','ios-download','ios-download-outline','md-download','logo-dribbble','logo-dropbox','ios-easel','ios-easel-outline','md-easel','ios-egg','ios-egg-outline','md-egg','logo-euro','ios-exit','ios-exit-outline','md-exit','ios-expand','md-expand','ios-eye','ios-eye-outline','md-eye','ios-eye-off','ios-eye-off-outline','md-eye-off','logo-facebook','ios-fastforward','ios-fastforward-outline','md-fastforward','ios-female','md-female','ios-filing','ios-filing-outline','md-filing','ios-film','ios-film-outline','md-film','ios-finger-print','md-finger-print','ios-flag','ios-flag-outline','md-flag','ios-flame','ios-flame-outline','md-flame','ios-flash','ios-flash-outline','md-flash','ios-flask','ios-flask-outline','md-flask','ios-flower','ios-flower-outline','md-flower','ios-folder','ios-folder-outline','md-folder','ios-folder-open','ios-folder-open-outline','md-folder-open','ios-football','ios-football-outline','md-football','logo-foursquare','logo-freebsd-devil','ios-funnel','ios-funnel-outline','md-funnel','ios-game-controller-a','ios-game-controller-a-outline','md-game-controller-a','ios-game-controller-b','ios-game-controller-b-outline','md-game-controller-b','ios-git-branch','md-git-branch','ios-git-commit','md-git-commit','ios-git-compare','md-git-compare','ios-git-merge','md-git-merge','ios-git-network','md-git-network','ios-git-pull-request','md-git-pull-request','logo-github','ios-glasses','ios-glasses-outline','md-glasses','ios-globe','ios-globe-outline','md-globe','logo-google','logo-googleplus','ios-grid','ios-grid-outline','md-grid','logo-hackernews','ios-hammer','ios-hammer-outline','md-hammer','ios-hand','ios-hand-outline','md-hand','ios-happy','ios-happy-outline','md-happy','ios-headset','ios-headset-outline','md-headset','ios-heart','ios-heart-outline','md-heart','md-heart-outline','ios-help','md-help','ios-help-buoy','ios-help-buoy-outline','md-help-buoy','ios-help-circle','ios-help-circle-outline','md-help-circle','ios-home','ios-home-outline','md-home','logo-html5','ios-ice-cream','ios-ice-cream-outline','md-ice-cream','ios-image','ios-image-outline','md-image','ios-images','ios-images-outline','md-images','ios-infinite','ios-infinite-outline','md-infinite','ios-information','md-information','ios-information-circle','ios-information-circle-outline','md-information-circle','logo-instagram','ios-ionic','ios-ionic-outline','md-ionic','ios-ionitron','ios-ionitron-outline','md-ionitron','logo-javascript','ios-jet','ios-jet-outline','md-jet','ios-key','ios-key-outline','md-key','ios-keypad','ios-keypad-outline','md-keypad','ios-laptop','md-laptop','ios-leaf','ios-leaf-outline','md-leaf','ios-link','ios-link-outline','md-link','logo-linkedin','ios-list','md-list','ios-list-box','ios-list-box-outline','md-list-box','ios-locate','ios-locate-outline','md-locate','ios-lock','ios-lock-outline','md-lock','ios-log-in','md-log-in','ios-log-out','md-log-out','ios-magnet','ios-magnet-outline','md-magnet','ios-mail','ios-mail-outline','md-mail','ios-mail-open','ios-mail-open-outline','md-mail-open','ios-male','md-male','ios-man','ios-man-outline','md-man','ios-map','ios-map-outline','md-map','logo-markdown','ios-medal','ios-medal-outline','md-medal','ios-medical','ios-medical-outline','md-medical','ios-medkit','ios-medkit-outline','md-medkit','ios-megaphone','ios-megaphone-outline','md-megaphone','ios-menu','ios-menu-outline','md-menu','ios-mic','ios-mic-outline','md-mic','ios-mic-off','ios-mic-off-outline','md-mic-off','ios-microphone','ios-microphone-outline','md-microphone','ios-moon','ios-moon-outline','md-moon','ios-more','ios-more-outline','md-more','ios-move','md-move','ios-musical-note','ios-musical-note-outline','md-musical-note','ios-musical-notes','ios-musical-notes-outline','md-musical-notes','ios-navigate','ios-navigate-outline','md-navigate','ios-no-smoking','ios-no-smoking-outline','md-no-smoking','logo-nodejs','ios-notifications','ios-notifications-outline','md-notifications','ios-notifications-off','ios-notifications-off-outline','md-notifications-off','md-notifications-outline','ios-nuclear','ios-nuclear-outline','md-nuclear','ios-nutrition','ios-nutrition-outline','md-nutrition','logo-octocat','ios-open','ios-open-outline','md-open','ios-options','ios-options-outline','md-options','ios-outlet','ios-outlet-outline','md-outlet','ios-paper','ios-paper-outline','md-paper','ios-paper-plane','ios-paper-plane-outline','md-paper-plane','ios-partly-sunny','ios-partly-sunny-outline','md-partly-sunny','ios-pause','ios-pause-outline','md-pause','ios-paw','ios-paw-outline','md-paw','ios-people','ios-people-outline','md-people','ios-person','ios-person-outline','md-person','ios-person-add','ios-person-add-outline','md-person-add','ios-phone-landscape','md-phone-landscape','ios-phone-portrait','md-phone-portrait','ios-photos','ios-photos-outline','md-photos','ios-pie','ios-pie-outline','md-pie','ios-pin','ios-pin-outline','md-pin','ios-pint','ios-pint-outline','md-pint','logo-pinterest','ios-pizza','ios-pizza-outline','md-pizza','ios-plane','ios-plane-outline','md-plane','ios-planet','ios-planet-outline','md-planet','ios-play','ios-play-outline','md-play','logo-playstation','ios-podium','ios-podium-outline','md-podium','ios-power','ios-power-outline','md-power','ios-pricetag','ios-pricetag-outline','md-pricetag','ios-pricetags','ios-pricetags-outline','md-pricetags','ios-print','ios-print-outline','md-print','ios-pulse','ios-pulse-outline','md-pulse','logo-python','ios-qr-scanner','md-qr-scanner','ios-quote','ios-quote-outline','md-quote','ios-radio','ios-radio-outline','md-radio','ios-radio-button-off','md-radio-button-off','ios-radio-button-on','md-radio-button-on','ios-rainy','ios-rainy-outline','md-rainy','ios-recording','ios-recording-outline','md-recording','logo-reddit','ios-redo','ios-redo-outline','md-redo','ios-refresh','md-refresh','ios-refresh-circle','ios-refresh-circle-outline','md-refresh-circle','ios-remove','md-remove','ios-remove-circle','ios-remove-circle-outline','md-remove-circle','ios-reorder','md-reorder','ios-repeat','md-repeat','ios-resize','md-resize','ios-restaurant','ios-restaurant-outline','md-restaurant','ios-return-left','md-return-left','ios-return-right','md-return-right','ios-reverse-camera','ios-reverse-camera-outline','md-reverse-camera','ios-rewind','ios-rewind-outline','md-rewind','ios-ribbon','ios-ribbon-outline','md-ribbon','ios-rose','ios-rose-outline','md-rose','logo-rss','ios-sad','ios-sad-outline','md-sad','logo-sass','ios-school','ios-school-outline','md-school','ios-search','ios-search-outline','md-search','ios-send','ios-send-outline','md-send','ios-settings','ios-settings-outline','md-settings','ios-share','ios-share-outline','md-share','ios-share-alt','ios-share-alt-outline','md-share-alt','ios-shirt','ios-shirt-outline','md-shirt','ios-shuffle','md-shuffle','ios-skip-backward','ios-skip-backward-outline','md-skip-backward','ios-skip-forward','ios-skip-forward-outline','md-skip-forward','logo-skype','logo-snapchat','ios-snow','ios-snow-outline','md-snow','ios-speedometer','ios-speedometer-outline','md-speedometer','ios-square','ios-square-outline','md-square','md-square-outline','ios-star','ios-star-outline','md-star','ios-star-half','md-star-half','md-star-outline','ios-stats','ios-stats-outline','md-stats','logo-steam','ios-stopwatch','ios-stopwatch-outline','md-stopwatch','ios-subway','ios-subway-outline','md-subway','ios-sunny','ios-sunny-outline','md-sunny','ios-swap','md-swap','ios-switch','ios-switch-outline','md-switch','ios-sync','md-sync','ios-tablet-landscape','md-tablet-landscape','ios-tablet-portrait','md-tablet-portrait','ios-tennisball','ios-tennisball-outline','md-tennisball','ios-text','ios-text-outline','md-text','ios-thermometer','ios-thermometer-outline','md-thermometer','ios-thumbs-down','ios-thumbs-down-outline','md-thumbs-down','ios-thumbs-up','ios-thumbs-up-outline','md-thumbs-up','ios-thunderstorm','ios-thunderstorm-outline','md-thunderstorm','ios-time','ios-time-outline','md-time','ios-timer','ios-timer-outline','md-timer','ios-train','ios-train-outline','md-train','ios-transgender','md-transgender','ios-trash','ios-trash-outline','md-trash','ios-trending-down','md-trending-down','ios-trending-up','md-trending-up','ios-trophy','ios-trophy-outline','md-trophy','logo-tumblr','logo-tux','logo-twitch','logo-twitter','ios-umbrella','ios-umbrella-outline','md-umbrella','ios-undo','ios-undo-outline','md-undo','ios-unlock','ios-unlock-outline','md-unlock','logo-usd','ios-videocam','ios-videocam-outline','md-videocam','logo-vimeo','ios-volume-down','md-volume-down','ios-volume-mute','md-volume-mute','ios-volume-off','md-volume-off','ios-volume-up','md-volume-up','ios-walk','md-walk','ios-warning','ios-warning-outline','md-warning','ios-watch','md-watch','ios-water','ios-water-outline','md-water','logo-whatsapp','ios-wifi','ios-wifi-outline','md-wifi','logo-windows','ios-wine','ios-wine-outline','md-wine','ios-woman','ios-woman-outline','md-woman','logo-wordpress','logo-xbox','logo-yahoo','logo-yen','logo-youtube','ios-loading'
      ],
      iconfontList: [
          'icon-xitongpeizhi',
          'icon-caidan1',
          'icon-chongdianzhuang1',
          'icon-dapingzhanshi',
          'icon-tongji',
          'icon-chakanjiexi',
          'icon-dingdandingdanmingxishouzhimingxi',
          'icon-dingweimian',
          'icon-shalou',
          'icon-icon-'
      ],
      modalTreeList: [],
      parentUID: '',
      powerList: []
    }
  },
  computed: {
    ...mapState(['tableHeight'])
  },
  mounted () {
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    toSearch (obj) {
      this.searchParams = obj
      this.getList()
    },
    toReset (obj) {
      this.searchParams = obj
      this.getList()
    },
    pageChange (pageIndex) {
      this.params.pageIndex = pageIndex
      this.getList()
    },
    pageSizeChange (pageSize) {
      this.params.pageSize = pageSize
      this.getList()
    },
    async getList () {
      this.loading = true
      await getMenusQuery(Object.assign({}, this.searchParams)).then((res) => {
        this.loading = false
        if (res.data.code === 0) {
          this.list = res.data.data
          let treeData = Object.assign([], this.list)
          if (treeData.length) {
            treeData.forEach((item) => {
              this.setDataVal(item)
            })
          }
          this.modalTreeList = [
            {
              id: '-1',
              name: '根目录',
              title: '根目录',
              children: treeData
            }
          ]
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    setDataVal (item) {
      item.title = item.name
      if (item.children && item.children.length) {
        item.children.forEach((child) => {
          item.title = item.name
          this.setDataVal(child)
        })
      } else {
        item.children = []
      }
    },
    toOpr (type, row) {
      this.oprType = type
      if (row) {
        this.modData = row
      }
      if (['add', 'mod'].includes(type)) {
        this.showModal = true
        if (type === 'mod') {
          this.initForm(row)
        }
      } else if (type === 'del') { // 删除
        this.$Modal.confirm({
          title: '删除',
          content: `确定删除该${row.type === 0 ? '目录' : '菜单'}?`,
          loading: true,
          onOk: async () => {
            await setMenusDel({
              id: row.id,
            }).then((res) => {
              if (res.data.code === 0) {
                this.$Message.success('操作成功!')
                this.getList()
                this.$Modal.remove()
              } else {
                this.$Message.error(res.data.message)
              }
            })
          }
        })
      }
    },
    modalCancel () {
      this.showModal = false
    },
    modalOk () {
      this.$refs.modalForm.validate((valid) => {
        if (valid) {
          let url = {
            add: setMenusAdd,
            mod: setMenusMod
          }
          let formData = {}
          Object.keys(this.modalFormData).forEach((key) => {
            let it = this.modalFormData[key]
            if (['isFrame', 'keepAlive'].includes(key)) {
              formData[key] = it === 1
            } else if (key === 'hidden') {
              formData[key] = it === 0
            } else {
              formData[key] = this.modalFormData[key]
            }
          })
          if (this.oprType === 'mod') {
            formData.id = this.modData.id
          }
          url[this.oprType](formData).then((res) => {
            if (res.data.code === 0) {
              this.$Message.success('操作成功!')
              this.showModal = false
              this.getList()
              this.$store.dispatch('GenerateRoutes').then(() => {
                this.$store.dispatch('setRoles', [])
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        }
      })
    },
    initForm(row) {
      Object.keys(this.modalFormData).forEach((key) => {
        if (['isFrame', 'keepAlive'].includes(key)) {
          this.modalFormData[key] = row[key] ? 1 : 0
        } else if (key === 'hidden') {
          this.modalFormData[key] = row[key] ? 0 : 1
        } else if (key === 'parentUID') {
          this.modalFormData.parentUID = this.modData.type === 0 ? '-1' : this.modData.parentUID
        } else {
          this.modalFormData[key] = row[key]
        }
      })
    },
    typeChange (val) {
      this.modalFormData.parentUID = val === 0 ? '-1' : ''
    },
    treeChange (val) {
      this.modalFormData.parentUID = val
    },
    getPowerList (searchVal) {
      getPowersQuery({
        pageIndex: 1,
        pageSize: 1000,
        name: searchVal
      }).then((res) => {
        if (res.data.code === 0) {
          this.powerList = res.data.data.dataSource
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    powerChange (val) {
      this.getPowerList(val)
    }
  },
  watch: {
    showModal (val) {
      if (!val) {
        this.$refs.modalForm.resetFields()
        this.modalFormData = Object.assign({}, formData)
        this.modData = {}
        this.oprType = ''
      } else {
        this.getPowerList('')
      }
    }
  }
}
</script>

<style scoped lang="less">
  .icon-select{
    /deep/.ivu-select-dropdown-list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    /deep/.ivu-select-item{
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      .ivu-icon, .iconfont{
        font-size: 20px;
      }
    }
  }
</style>
